import React, { forwardRef } from "react";
import classNames from "classnames";


interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: "primary" | "danger" | "warning" | "secondary" | "light"
        | "outline-primary" | "outline-danger" | "outline-warning" | "outline-secondary"
        | "text" | "text-transparent";
    size?: "xs" | "sm" | "md" | "full";
    icon?: boolean;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
    const {
        variant,
        size,
        icon,
        className: propsClassName,
        children,
        ...rest
    } = props;

    return (
        <button ref={ref}
                className={classNames(
                    "btn",
                    variant && `btn-${variant}`,
                    size && `btn-${size}`,
                    icon && "btn-ic",
                    propsClassName
                )}
                {...rest}
        >
            {children}
        </button>
    );
});

export default Button;
